import { render, staticRenderFns } from "./contractMasterManySlave.vue?vue&type=template&id=0f204214&scoped=true&"
import script from "./contractMasterManySlave.vue?vue&type=script&lang=js&"
export * from "./contractMasterManySlave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f204214",
  null
  
)

export default component.exports